export const config = [
  {
    from: 'develop-your-product',
    to: 'Custom software development',
  },
  {
    from: 'scale-your-team',
    to: 'Modsen in-house team augmentation service',
  },
  {
    from: 'mobile-development',
    to: 'Mobile Development',
  },
  {
    from: 'frontend-developer',
    to: 'Front-end developer',
  },
  {
    from: 'front-end-development',
    to: 'Front-end-development',
  },
  {
    from: 'back-end-development',
    to: 'Back-end',
  },
  {
    from: 'devops-and-cloud-computing',
    to: 'DevOps & Cloud Computing',
  },
  {
    from: 'devops-services',
    to: 'DevOps Services',
  },
  {
    from: 'fintech',
    to: 'Fintech',
  },
  {
    from: 'enterprise',
    to: 'Enterprise',
  },
  {
    from: 'medtech',
    to: 'Medtech',
  },
  {
    from: 'iot',
    to: 'IoT',
  },
  {
    from: 'social-networking',
    to: 'Social Networking',
  },
  {
    from: 'logistics',
    to: 'Logistics',
  },
  {
    from: 'travel',
    to: 'Travel',
  },
  {
    from: 'about-us',
    to: 'About Us',
  },
  {
    from: 'news',
    to: 'News',
  },
  {
    from: 'career',
    to: 'Career',
  },
  {
    from: 'partnership',
    to: 'Partnership',
  },
  {
    from: 'blog',
    to: 'Blog',
  },
  {
    from: 'portfolio',
    to: 'Portfolio',
  },
  {
    from: 'approach',
    to: 'Approach',
  },
  {
    from: 'react-solutions',
    to: 'React',
  },
  {
    from: 'angular-solutions',
    to: 'Angular-solutions',
  },
  {
    from: 'vuejs-solutions',
    to: 'VueJS-solutions',
  },
  {
    from: 'ios',
    to: 'iOS',
  },
  {
    from: 'android-developers',
    to: 'Android developers',
  },
  {
    from: 'nodejs-solutions',
    to: 'Node JS',
  },
  {
    from: 'java-application-development-services',
    to: 'Java',
  },
  {
    from: 'center-stage-efficiency',
    to: ' Center Stage Efficiency: How Operations Management Software Steals The Show For Success',
  },
  {
    from: 'python-solutions',
    to: 'Python',
  },
  {
    from: 'react-native',
    to: 'React Native',
  },
  {
    from: 'ci-cd-integration',
    to: 'CI/CD',
  },
  {
    from: 'iaas-solutions',
    to: 'IaaS',
  },
  {
    from: 'orchestration-solutions',
    to: 'Orchestration',
  },
  {
    from: 'thank-you',
    to: 'Thank-you',
  },
  {
    from: 'market-analysis',
    to: 'Solid software solution for market data analysis',
  },
  {
    from: 'desk-booking-app-development-services',
    to: 'Web-based Desk Booking Platform',
  },
  {
    from: 'booking-solution',
    to: 'Remote space booking solution',
  },
  {
    from: 'tracking-app',
    to: 'Powerful tracking app',
  },
  {
    from: 'train-travel-application-modernization-loyalty-programs',
    to: 'Enhanced Train Travel: Loyalty Programs Meet Rail App Modernization',
  },
  {
    from: 'lets-work',
    to: 'Let’s work',
  },
  {
    from: 'vacancy',
    to: 'Vacancy',
  },
  {
    from: 'java-senior',
    to: 'Java senior',
  },
  {
    from: '333',
    to: 'Middle angular',
  },
  {
    from: '12355',
    to: 'Middle python',
  },
  {
    from: 'selling-products-services-businesses',
    to: 'Selling financial products and services to businesses',
  },
  {
    from: 'smart-city',
    to: 'Smart city IOT solution for energy performance optimization',
  },
  {
    from: 'booking-train-tickets',
    to: 'Booking and searching for train tickets online',
  },
  {
    from: 'streaming-app',
    to: 'Sports home training streaming app',
  },
  {
    from: 'farm-data-management-software',
    to: 'Data Management Software For An Agricultural Holding',
  },
  {
    from: 'sms-email-communication-app',
    to: 'SMS and e-mail communication app',
  },
  {
    from: 'custom-legal-software-development-services',
    to: 'A platform for connecting lawyers and legal service companies',
  },
  {
    from: 'real-estate-search-app',
    to: 'Fast and convenient real-estate search app',
  },
  {
    from: 'intranet-portal-for-education-company',
    to: 'Intranet Portal For Education Company',
  },
  {
    from: 'delivery-management-app',
    to: '.NET-based Delivery Management App',
  },
  {
    from: 'banking-services',
    to: 'Web application for banking services',
  },
  {
    from: 'cross-platfrom-mobile-app-development',
    to: 'Cross-platform mobile marketplace',
  },
  {
    from: 'automated-financial-reporting-software',
    to: 'Software for automatic financial report generation',
  },
  {
    from: 'legal-service-app',
    to: 'Legal service app modernization',
  },
  {
    from: 'interservice-app',
    to: 'Interservice authorization',
  },
  {
    from: 'business-loans',
    to: 'Online small business loans platform',
  },
  {
    from: 'hedge-accounting-software',
    to: 'Hedge accounting software',
  },
  {
    from: 'web-app-for-medical-cards-storage',
    to: 'Web Application For Medical Cards',
  },
  {
    from: 'car-rental-app',
    to: 'Car rental app',
  },
  {
    from: 'telemedicine-software-platform',
    to: 'Telemedicine Software Platform for Therapy Services',
  },
  {
    from: 'ai-powered-logistics-platform',
    to: 'AI-powered logistics platform',
  },
  {
    from: 'sms-business-messaging-for-finance',
    to: 'SMS and RMM Business Text Messaging for Finance',
  },
  {
    from: 'application-for-medical-equipment-provision',
    to: 'Application For Medical Equipment Provision',
  },
  {
    from: 'internet-of-things-software',
    to: 'IoT device management software',
  },
  {
    from: 'tour-booking-software-development',
    to: 'Online System For Tour And Activity Booking',
  },
  {
    from: 'truck-booking-and-monitoring-platform',
    to: 'Truck Booking and Monitoring Platform',
  },
  {
    from: 'mobile-banking-development',
    to: 'Mobile banking development',
  },
  {
    from: 'modsen-top-financial-technology',
    to: 'Modsen as a top fintech developer',
  },
  {
    from: 'internet-of-things',
    to: 'Internet of Things',
  },
  {
    from: 'geographically-distributed-development-teams',
    to: 'Geographically distributed development teams',
  },
  {
    from: 'data-privacy',
    to: 'Data privacy',
  },
  {
    from: 'business-must-haves',
    to: 'Business must haves in 2022',
  },
  {
    from: 'what-is-xaas',
    to: 'What is XaaS',
  },
  {
    from: 'ten-mistakes',
    to: 'Ten mistakes',
  },
  {
    from: 'mobile-app-trends',
    to: 'Mobile app trends',
  },
  {
    from: 'top-development-trends',
    to: 'Top development trends',
  },
  {
    from: 'modsen-in-top-lists-of-itrate-platform',
    to: 'Modsen in top lists',
  },
  {
    from: 'april-team-building',
    to: 'April team building',
  },
  {
    from: 'designrush-recommends-modsen',
    to: 'Designrush recommends Modsen',
  },
  {
    from: 'meet-up-it-community',
    to: 'Meet up it community',
  },
  {
    from: 'online-presentation',
    to: 'Online presentation',
  },
  {
    from: 'stand-with-ukraine',
    to: 'Stand with Ukraine',
  },
  {
    from: 'polotsk-meet-up',
    to: 'Polotsk meet-up',
  },
  {
    from: 'new-year-party',
    to: 'New Year party',
  },
  {
    from: 'financial-technology-mobile-app',
    to: 'Fintech mobile app development tech stack trends',
  },
  {
    from: 'crm-implementation',
    to: 'CRM implementation for insurance company',
  },
  {
    from: 'rn-development',
    to: 'React Native development in 2022',
  },
  {
    from: 'the-best-react-native-developer',
    to: 'The Best React-Native developer in 2022',
  },
  {
    from: 'financial-services-industry',
    to: 'Approaching Financial Services Industry Challenges in 2022',
  },
  {
    from: 'big-data-management-in-banking',
    to: 'Big Data Management Value in Banking and Finance Industry',
  },
  {
    from: 'dot-net-solutions',
    to: 'Top .NET software developers',
  },
  {
    from: 'staff-augmentation-service',
    to: 'The Unobvious Benefits of Staff Augmentation Service',
  },
  {
    from: 'smart-technologies-of-your-business',
    to: 'Smart Technologies on Guard of Your Business Development',
  },
  {
    from: 'how-modsen-pulls-off-major-staff-augmentation-challenges',
    to: 'How Modsen Tackles Staff Augmentation Challenges',
  },
  {
    from: 'modsen-is-a-winner-of-the-Fintech-awards-2022',
    to: 'Modsen is a winner of the FinTech Awards 2022',
  },
  {
    from: 'digital-transformation',
    to: 'CRM Implementation for Insurance Company',
  },
  {
    from: 'staff-augmentation-for-online-store-scaling',
    to: 'Staff Augmentation Services For Fintech Software Scaling',
  },
  {
    from: 'staff-augmentation-services-for-custom-app-development',
    to: ' In-House TeamE Augmentation For A Software Development Services Provider',
  },
  {
    from: 'how-to-ensure-quality-monitoring-of-an-outstaff-project-team',
    to: 'How To Ensure Quality Monitoring Of An Outstaff Project Team',
  },
  {
    from: 'internal-airline-app',
    to: 'Internal Airline App',
  },
  {
    from: 'signs-augmentation-staff-service-is-what-you-need',
    to: '7 Signs Staff augmentation service is what you need',
  },
  {
    from: 'food-delivery-cross-platform-app-development',
    to: 'Mobile App for a Chain of Restaurants',
  },
  {
    from: 'intranet-software-for-home-appliance-manufacturer',
    to: 'Intranet Software Development for Home Appliance Manufacturing Company',
  },
  {
    from: 'erp-software-for-chemical',
    to: 'ERP Software for Chemical Enterprise',
  },
  {
    from: 'best-developer-2022-in-multiple-nominations',
    to: 'Best developer 2022 in multiple nominations',
  },
  {
    from: 'modsen-summer-party-2022',
    to: 'Modsen summer party 2022',
  },
  {
    from: 'platform-for-improving-diagnostic-accuracy',
    to: 'A platform for improving diagnostic accuracy',
  },
  {
    from: 'ai-powered-platform-for-patient-diagnosing',
    to: 'Ai-Based Platform For Improving Diagnostic Accuracy And Patient Treatment Effectiveness',
  },
  {
    from: 'crm-software-for-food-industry',
    to: 'CRM Software for Food Distribution Enterprise',
  },
  {
    from: 'iot-saas-based',
    to: 'IoT SaaS-based platform',
  },
  {
    from: 'iot-for-retailers',
    to: 'IoT application for retailers',
  },
  {
    from: 'fitness-tracking-system',
    to: 'Fitness tracking system',
  },
  {
    from: 'data-engineer',
    to: 'Data Engineer',
  },
  {
    from: 'net-developer',
    to: 'Full-Stack .Net Developer',
  },
  {
    from: 'testing-engineer',
    to: 'Middle QA Engineer',
  },
  {
    from: 'middle-react-developer',
    to: 'Middle React Developer',
  },
  {
    from: 'nodejs-developer',
    to: 'Node JS Developer',
  },
  {
    from: 'python-middle',
    to: 'Middle Python Developer',
  },
  {
    from: 'angular-middle',
    to: 'Middle Angular Developer',
  },
  {
    from: 'java-senior',
    to: 'Senior Java Developer',
  },
  {
    from: 'iot-saas-based',
    to: 'IoT SaaS-based platform',
  },
  {
    from: 'online-meetups-for-future-developers',
    to: 'Online Meetups for Future Developers',
  },
  {
    from: 'modsen-net-tech-talks-hackathon',
    to: 'Modsen .Net Tech Talks',
  },
  {
    from: 'modsen-net-tech-talks',
    to: 'Modsen .Net Tech Talks',
  },
  {
    from: 'iot-saas-based',
    to: 'IoT SaaS-based platform',
  },
  {
    from: 'iot-for-retailers',
    to: 'IoT application for retailers',
  },
  {
    from: 'corporate-platform-for-financial-company',
    to: 'Corporate platform for a financial company',
  },
  {
    from: 'september-modsen-tech-talks',
    to: 'September Modsen Tech Talks',
  },
  {
    from: 'iot-platform-for-logistics-it-solutions-provider',
    to: 'Logistics IoT platform',
  },
  {
    from: 'mobile-apps-internet-banking',
    to: 'Mobile apps and internet banking',
  },
  {
    from: 'ten-myths-about-it-staff',
    to: '10 myths about IT staff augmentation debunked by Modsen’s CTO',
  },
  {
    from: 'it-career-development',
    to: ' IT Career Development with Modsen',
  },
  {
    from: 'hiring-fullstack-developer',
    to: 'Hiring a full stack developer instead of a team of dedicated engineers: why it may be the best bet for a business',
  },
  {
    from: 'vacancy-management-software',
    to: 'Vacancy management software',
  },
  {
    from: 'video-advertising-platform',
    to: 'Video advertising platform',
  },
  {
    from: 'ad-analytics-platform',
    to: 'Advertising analytics platform',
  },
  {
    from: 'agricultural-data-management-automation-software',
    to: 'Agricultural Data Management Software',
  },
  {
    from: 'trading-education-platform',
    to: 'Migration of an online trading education platform',
  },
  {
    from: 'distance-learning-platform',
    to: 'Distance learning platform',
  },
  {
    from: 'sale-purchase-platform',
    to: 'Software licenses sale-purchase platform',
  },
  {
    from: 'emergency-services-management-software-development',
    to: 'Smart Platform For Emergency Services Management',
  },
  {
    from: 'wage-access-platform',
    to: 'Earned Wage Access Platform',
  },
  {
    from: 'vr-technology-for-heavy-industry',
    to: 'VR Training App For Heavy Industry Workers',
  },
  {
    from: 'modsen-halloween-party',
    to: 'Modsen Halloween party',
  },
  {
    from: 'upcoming-frontend-trends',
    to: 'Uncovering the Upcoming Front-end Trends of 2023',
  },
  {
    from: 'modsen-company-presentation',
    to: 'Talking of the IT industry development prospects',
  },
  {
    from: 'modsen-net-development',
    to: 'Modsen .NET Development: A look From the Inside',
  },
  {
    from: 'modsen-wrapping-up-2022',
    to: 'CEO at Modsen about 2022 outcomes, ambitious plans and curious insights',
  },
  {
    from: 'whats-behind-all-hype-about-python',
    to: 'What’s behind all the hype about Python? Uncovering the reasons for unprecedented success',
  },
  { from: 'monitoring', to: 'Monitoring of the crops processing and delivery' },
  {
    from: 'what-is-ad-tech',
    to: 'Cutting-edge technologies for effective advertising, or what is AdTech',
  },
  {
    from: 'cybersecurity-and-ai',
    to: 'When AI meets cybersecurity. Rock-solid protection of your software in real-time',
  },
  {
    from: 'empowering-educators-and-transforming-schools',
    to: 'Empowering Educators and Transforming Schools',
  },
  {
    from: 'cto-best-recruiter',
    to: 'Why CTO is the best recruiter, or reasons to pivot away from agency-based in-house team augmentation',
  },
  {
    from: 'smart-system-for-gamer',
    to: 'Smart system for gamer churn prediction',
  },
  {
    from: 'agile-methodologies',
    to: 'Approach beneficial for the client. Modsen experience in leveraging Agile methodologies',
  },
  {
    from: 'vr-software-development-services',
    to: 'Video Surveillance System VR Showcase',
  },
  {
    from: 'chat-gpt',
    to: 'ChatGPT as a revolutionary tool for the world of business',
  },
  {
    from: 'top-tier-software-dev-partner',
    to: 'Modsen as a top-tier software development partner. An interview with Head of Business Development',
  },
  {
    from: 'perfect-project',
    to: 'Building the Perfect Project Team: How Modsen Ensures Your Success',
  },
  {
    from: 'react-native-news',
    to: 'React Native as a №1 solution for mobile app development. Optimizing costs without losing on functionality',
  },
  {
    from: 'new-cto',
    to: "The Best is Yet to Come: Modsen Company's New CTO is Here to Make Waves",
  },
  {
    from: 'ai-impact-business-landscape',
    to: 'From Science Fiction to Reality: The Impact of AI on Today’s Business Landscape',
  },
  {
    from: 'must-have-features-for-your-restaurants-mobile-app',
    to: 'Elevating Your Restaurant Experience: Top Mobile App Features for 2023',
  },
  {
    from: 'java-destiny',
    to: 'Alive Or Doomed? Java As A Relevant Coding Language Providing Extensive Business Opportunities',
  },
  {
    from: 'new-head-of-js-development-department',
    to: 'Modsen’s Secret Weapon for JS Development: Meet Marina Krivel, the New Head of Department',
  },
  {
    from: 'intern-developer',
    to: 'Trainee .NET developer',
  },
  {
    from: 'trainee-js',
    to: 'Trainee JS developer',
  },
  {
    from: 'android-kotlin-developer',
    to: 'Android (Kotlin) developer',
  },
  {
    from: 'devops-aws',
    to: 'Middle/Senior devOps AWS',
  },
  {
    from: 'ios-swift-developer',
    to: 'iOS swift developer',
  },
  {
    from: 'php-developer',
    to: 'Middle/Senior php developer',
  },
  {
    from: 'flutter-developer',
    to: 'Flutter developer',
  },
  {
    from: 'fullstack-net-developer',
    to: 'Senior Full-Stack .NET developer',
  },
  {
    from: 'sales-manager',
    to: 'Sales manager',
  },
  {
    from: 'gamedev',
    to: 'Gamedev outsourcing at Modsen: a duo worth betting on',
  },
  {
    from: 'growing-more-with-less',
    to: 'Growing More with Less: How Technology is Transforming Agriculture',
  },
  {
    from: 'big-data-medical-record-system-layout',
    to: 'Comprehensive Big Data Medical Record System',
  },
  {
    from: 'how-modsen-handles-mobile-app-development-risks',
    to: 'How Modsen handles mobile app development risks',
  },
  {
    from: 'fashion-ecommerce-platform',
    to: 'Custom Fashion E-commerce Platform',
  },
  {
    from: 'big-data-solution-for-online-bank',
    to: 'Big Data Solution for Online Bank in Eastern Europe',
  },
  {
    from: 'erp-solutions-for-business',
    to: 'ERP Solutions: Revealing Hidden Potential For Your Business',
  },
  {
    from: 'wireless-sensor-system-for-packaging-company',
    to: 'Wireless sensor system for packaging company',
  },
  {
    from: 'document-processing-machine-learning-finance-case-study',
    to: 'Machine Learning For Document Processing In Finance',
  },
  {
    from: 'ai-based-investment-monitoring-platform',
    to: 'AI-based Investment Management Platform',
  },
  {
    from: 'e-commerce-transformation-ai-computer-vision-bi-platform',
    to: 'AI-Based Logistics Platform',
  },
  {
    from: 'digital-transformation-and-automation-with-ai',
    to: 'Embracing the Digital Era: Transforming Your Business with AI',
  },
  {
    from: 'all-you-need-to-know-about-flutter-crafting-cross-platform-apps',
    to: 'Crafting Cross-platform Apps with Flutter: Everything You Need to Know',
  },
  {
    from: 'new-head-dotnet-development-modsen',
    to: 'From Code Crusader to Captain: New Head of .net Development at Modsen!',
  },
  {
    from: 'cross-platforming-with-react-native',
    to: 'Being Native Everywhere: Cross-Platforming With React Native',
  },
  {
    from: 'cross-platform-payment-app-development',
    to: 'Transforming international payments: the app development journey',
  },
  {
    from: 'cracking-data-science-code-business-insights',
    to: 'Cracking the data science code: business essentials unveiled',
  },
  {
    from: 'pos-mobile-app',
    to: 'E-commerce software with an Integrated POS Mobile App',
  },
  {
    from: 'why-crm-is-just-right',
    to: 'Customer Is King: Why CRM Solution Is Just Right?',
  },
  {
    from: 'blockchain-technology-and-smart-contracts',
    to: 'Blockchain and Smart Contracts: Simplifying Savings for the Savvy',
  },
  {
    from: 'blockchain-digital-identity-solution',
    to: 'BLOCKCHAIN-Based Digital Identity Management Solution for Fintech',
  },
  {
    from: 'blockchain-payment-cross-border-solution',
    to: 'Blockchain-Based Payment Solution',
  },
  {
    from: 'building-ecommerce-site-electronic-retailer',
    to: 'Building an E-Commerce Website for a Large Electronic Retailer',
  },
  {
    from: 'cryptocurrency',
    to: 'Cryptocurrency',
  },
  {
    from: 'design-991',
    to: 'Design 991',
  },
  {
    from: 'resource-app-layout',
    to: 'Resource',
  },
  {
    from: 'leveraging-ai-and-data-science',
    to: 'Ai And Data Science: Distinct Puzzle Pieces, One Complete Picture',
  },
  {
    from: 'peer-to-peer-lending',
    to: 'Peer-To-Peer Lending: Debunking Myths And Unveiling Potential',
  },
  {
    from: 'php-application-development',
    to: 'PHP',
  },
  {
    from: 'flutter-solutions',
    to: 'Flutter',
  },
  {
    from: 'smart-iot-app-fitness-centers',
    to: 'Smart IoT App For Fitness Centers',
  },
  {
    from: 'web3-as-an-ultimate-stage-of-internet-evolution',
    to: 'Web3: Engage, Interact, Decentralize',
  },
  {
    from: 'mobile-app-for-local-event-discovery-and-taxi-booking',
    to: '60 % Revenue Boost With Geolocation-Based Event Discovery And Taxi Booking Mobile App',
  },
  {
    from: 'iot-device-management-platform',
    to: 'IoT Device Management Software',
  },
  {
    from: 'in-vehicle-targeted-advertising-solution',
    to: 'Improving ROI with in-vehicle targeted advertising: a game-changer',
  },
  {
    from: 'financial-management-software-development',
    to: 'Financial Management Software: Scaling Up Business Efficiency',
  },
  {
    from: 'blockchain-getting-started-fintech',
    to: 'Blockchain 101: Getting Started With Fintech',
  },
  {
    from: 'php-application-development',
    to: 'PHP',
  },
  {
    from: 'flutter-solutions',
    to: 'Flutter',
  },
  {
    from: 'smart-iot-app-fitness-centers',
    to: 'Smart IoT App For Fitness Centers',
  },
  {
    from: 'scm-software-with-confidence',
    to: 'SCM Software: Streamlining Supply Chains With Confidence',
  },
  {
    from: 'streamlining-business-processses-with-smart-contracts',
    to: 'Don’t Sign, Just Click: Exploring the World of Smart Contracts in Finance',
  },
  {
    from: 'web3-vs-centralized-finance-banking',
    to: 'Web3 vs. Centralized Finance: The Evolution of Banking',
  },
  {
    from: 'microsoft-partner',
    to: 'Marking A New Milestone In Technology Excellence: Modsen Is Now An Official Microsoft Partner',
  },
  {
    from: 'smart-contract-development',
    to: 'Done Within a click: how swart contrast are reshaping the finance industry',
  },
  {
    from: 'devops-automation-services-streamlining',
    to: 'DevOps automating solutions: In streamlining is a victory',
  },
  {
    from: 'full-stack-engineer-for-mobile-back-end-overhaul-hotel-app',
    to: '4 Weeks, 1 Engineer: Hotel App Mobile Back-End Gets Essential Updates',
  },
  {
    from: 'net-technology-essentials-for-developers-and-businesses',
    to: '.NET as a universal framework: Harnessing versatility and unfolding potential',
  },
  {
    from: 'data-python-engineer',
    to: 'Data Python Engineer',
  },
  {
    from: 'lead-generation-specialist',
    to: 'Lead Generation Specialist',
  },
  {
    from: 'middle-java-developer',
    to: 'Middle Java Developer',
  },
  {
    from: 'business-analyst',
    to: 'Business Analyst',
  },
  {
    from: 'being-well-with-heathcare-software-solutions',
    to: 'Healthcare Software: It’s Hip To Stay Well With Innovations',
  },
  {
    from: 'staff-augmentation-services-for-education-software-development',
    to: 'Revamping The Educational Process Management Software',
  },
  {
    from: 'full-stack-developer-for-hotel-software-development',
    to: 'Efficient Hotel Software Development: Full-Stack Expertise',
  },
  {
    from: 'custom-real-estate-software-solution',
    to: 'Real-Estate Search App Design And Development',
  },
  {
    from: 'legal-app-modernization-services',
    to: 'Legal Service App Modernization',
  },
  {
    from: 'desk-booking-mobile-application',
    to: 'Custom mobile space booking app development',
  },
  {
    from: 'predictive-analytics-for-gaming',
    to: 'Smart system for gamer churn prediction',
  },
  {
    from: 'iot-software',
    to: 'Through IoT Software: Using The Transformative Potential',
  },
  {
    from: 'interview-with-head-hr',
    to: 'Wrapping up 2023 with Modsen Head of HR',
  },
  {
    from: 'crop-delivery-and-processing-solution',
    to: 'Empowering crop delivery and monitoring software',
  },
  {
    from: 'modsen-wrapping-up-2023-with-cto',
    to: 'Reflecting on 2023: Modsen’s CTO on tech frontiers, resilient teams, and future vision',
  },
  {
    from: 'ramping-up-the-limits',
    to: 'Ramping Up The Limits: How Web3 Revolutionize Industries',
  },
  {
    from: 'ceo-recap-2023',
    to: 'Leading through change: A year-end interview with Modsen CEO',
  },
  {
    from: 'early-testing',
    to: 'Early testing: Mere overkill or absolute necessity?',
  },
  {
    from: 'medtech-2024-trends-insights',
    to: 'Medtech 2024: Trends, insights, and our impactful advisory initiative',
  },
  {
    from: 'ai-driven-customer-experience-solution-for-airline-logistics',
    to: 'FlightSecAI: Reshaping Arab airline logistics via customer-centric portal',
  },
  {
    from: 'data-security-interview-with-modsen-cto',
    to: 'Security essentials: Modsen CTO on how we safeguard every bit of client data',
  },
  {
    from: 'ai-powered-virtual-assistant-for-warehouse-management',
    to: 'AI-powered virtual assistant for warehouse management',
  },
  {
    from: 'startup-challenges-and-solutions',
    to: 'Solving the startup puzzle: Modsen’s key cases and solutions in 2023',
  },
  {
    from: 'iot-software-for-trucking',
    to: 'Optimizing perishable goods logistics through IoT technology',
  },
]
